import { useRef, useState } from "react";
import {
  Typography,
  Snackbar,
  Alert,
  Button,
  AppBar,
  IconButton,
  Toolbar,
  DialogContent,
  Stack,
  Box,
} from "@mui/material";
import {
  Close as CloseIcon,
  Edit as EditIcon,
  PersonRemove as DissociateIcon,
} from "@mui/icons-material";
import { prettify, renderEUDateTime } from "../../../utils/utils";
import { LoadingError, LoadingPaper } from "../../LoadingComponents";
import { EditableInputDisplay, useEditMode } from "../../EditableComponents";
import { useGetSmartboxById, usePutSmartboxById } from "../useSmartboxQueries";

function ViewSmartbox({ smartbox_id, closeModal, _editMode }) {
  // === web service queries/mutations ===
  const smartboxQuery = useGetSmartboxById(smartbox_id);
  const editMutation = usePutSmartboxById(smartbox_id, closeModal);

  // === edit mode ===
  const {
    editMode,
    enterEditMode,
    cancelEditMode,
    confirmEditMode,
    updateEditState,
    setQueryKey,
  } = useEditMode({
    editModeEnabled: _editMode,
    updateMutation: editMutation,
  });
  setQueryKey(["smartboxes", smartbox_id]);

  return (
    <>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={closeModal}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      {smartboxQuery.isLoading ? (
        <LoadingPaper />
      ) : smartboxQuery.isError ? (
        <LoadingError error={smartboxQuery.error} />
      ) : (
        <DialogContent>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h5" component="div">
            Visualizza gateway
          </Typography>

          <Stack spacing={2} direction={"column"}>
            <Box sx={{ width: "100%" }}>
              {/* Azioni */}
              <Box sx={{ float: "left" }}>
                <Button // MODIFICA
                  style={{ margin: "5px" }}
                  color={editMode ? "success" : "warning"}
                  variant="contained"
                  onClick={editMode ? confirmEditMode : enterEditMode}
                >
                  <EditIcon sx={{ marginRight: "5px" }} />
                  {editMode ? "Conferma" : "Modifica"}
                </Button>
              </Box>
            </Box>
            {/* Informazioni di base */}
            <Box
              sx={{
                display: "grid",
                margin: "auto",
                gridTemplateColumns: "1fr 1fr",
                width: "100%",
              }}
            >
              <>
                <Box sx={{ margin: "10px" }}>
                  <EditableInputDisplay
                    id={"description"}
                    label={"Descrizione:"}
                    initialValue={smartboxQuery.data.description}
                    setEditMode={editMode}
                    inputMode={"text"}
                    setParentValue={updateEditState}
                  />

                  <EditableInputDisplay
                    id={"is_online"}
                    label={"Stato (online)"}
                    initialValue={smartboxQuery.data.is_online}
                    setEditMode={editMode}
                    inputMode={"bool"}
                    setParentValue={updateEditState}
                  />
                  <EditableInputDisplay
                    id={"is_installed"}
                    label={"Stato (installato)"}
                    initialValue={smartboxQuery.data.is_installed}
                    setEditMode={editMode}
                    inputMode={"bool"}
                    setParentValue={updateEditState}
                  />
                </Box>
                <Box sx={{ margin: "10px" }}>
                  <EditableInputDisplay
                    id={"serial_number"}
                    label={"Numero seriale:"}
                    initialValue={smartboxQuery.data.serial_number}
                    setEditMode={editMode}
                    inputMode={"text"}
                    setParentValue={updateEditState}
                  />

                  <Typography>
                    <strong>Ultima connessione:</strong>{" "}
                    {renderEUDateTime(smartboxQuery.data.last_connection)}
                  </Typography>
                  <EditableInputDisplay
                    id={"note"}
                    label={"Note:"}
                    initialValue={smartboxQuery.data.note}
                    setEditMode={editMode}
                    inputMode={"text"}
                    setParentValue={updateEditState}
                  />
                </Box>
              </>
            </Box>
          </Stack>
        </DialogContent>
      )}
    </>
  );
}

export default ViewSmartbox;
